<template>
	<span v-if="hasFavorites" class="action-container">
		<a
			href="#"
			class="action gold"
			@click.prevent="$emit('load')"
		>
			<Icon icon="star"/>
			<span class="count-bubble">{{ favoritesCount }}</span>
		</a>
	</span>
</template>

<script>
import Icon from "@/vue/icon/Icon";

export default {

	components: {
		Icon,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
	},

	computed: {
		hasFavorites ()
		{
			return this.favoritesCount > 0;
		},
		favoritesCount ()
		{
			return this.job.favorite.count;
		},
	},
}
</script>
